// extracted by mini-css-extract-plugin
export default {"container":"FormPendaftaran_container__z-n1i","card":"FormPendaftaran_card__stz-T","title":"FormPendaftaran_title__lPoaa"};